import i18n from "i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
  Input,
  MessageBar,
} from "@fluentui/react-components";
import { AddRegular, Dismiss24Regular } from "@fluentui/react-icons";
import { useState } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { ITeamDto } from "../../../Models/ITeamDto";

interface IDialogAddTeamProps {
  getMyOwnTeams(): void;
  teams: ITeamDto[];
}
function DialogAddTeam(props: IDialogAddTeamProps) {
  const alphabet = /[a-zA-Z0-9]/g;
  const [error, setError] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [inputText, setInputText] = useState<string>("");
  const [addTeamValues, setAddTeamValues] = useState({ teamName: "" });
  const handleAddTeamValuesChange = (name: string, val: any) => {
    setAddTeamValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };
  const addTeam = () => {
    fetchWrapper
      .postWithAuth(baseUrl + "/api/teams/Create", {
        Teamname: addTeamValues.teamName,
      })
      .then((result: any) => {
        props.getMyOwnTeams();
        handleAddTeamValuesChange("teamName", "");
      });
  };
  return (
    <Dialog open={openDialog}>
      <Button
        onClick={() => {
          setOpenDialog(true);
        }}
        appearance="subtle"
        icon={<AddRegular />}
      >
        {i18n.t<string>("addTeam")}
      </Button>

      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("addTeam")}</DialogTitle>
          <DialogContent>
            <Field>
              {i18n.t<string>("addTeamText")}
              <Input
                placeholder="Teamname"
                style={{ marginTop: "10px" }}
                onKeyDown={(data) => {
                  if (data.key == "Enter") {
                    addTeam();
                    setOpenDialog(false);
                  }
                }}
                onChange={(ev, data) => {
                  let tempText = data.value;
                  if (tempText != "")
                    handleAddTeamValuesChange("teamName", tempText);
                  setInputText(data.value);
                }}
              />
            </Field>
            {error && (
              <MessageBar
                style={{ marginTop: "10px", width: "100%" }}
                intent={"error"}
              >
                Der Name ist ungültig
              </MessageBar>
            )}
          </DialogContent>
          <DialogActions style={{ width: "107%" }}>
            <Button
              appearance={"primary"}
              disabled={inputText ? false : true}
              icon={<AddRegular />}
              onClick={() => {
                if (alphabet.test(addTeamValues.teamName)) {
                  addTeam();
                  setOpenDialog(false);
                  setError(false);
                } else setError(true);
              }}
            >
              {i18n.t<string>("addTeam")}
            </Button>
            <Button
              onClick={() => {
                setOpenDialog(false);
                handleAddTeamValuesChange("teamName", "");
                setInputText("");
              }}
              icon={<Dismiss24Regular />}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogAddTeam;
